import chunk from 'lodash/chunk'
import reverse from 'lodash/reverse'

export function formatNumber(value: number): string {
  const digits = value.toString().split('')
  return reverse(chunk(reverse(digits), 3))
    .map((group) => reverse(group).join(''))
    .join(',')
}
